import { render, staticRenderFns } from "./VideoRecommend.vue?vue&type=template&id=537ff2ec&scoped=true&"
import script from "./VideoRecommend.vue?vue&type=script&lang=js&"
export * from "./VideoRecommend.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecommend.vue?vue&type=style&index=0&id=537ff2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ff2ec",
  null
  
)

export default component.exports